var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-content"},[_c('v-container',[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.order)?_c(_vm.selectedComponent,{tag:"component",attrs:{"item":_vm.order,"transition":"slide-y-transition"},on:{"nextStep":_vm.changeStep}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }